const Assets: any = {
	O2_video_background: "O2-session-video-background.jpg",
	Apollo_video_background: "Apollo-session-video-background.jpg",
	'Studio 54_video_background': "Studio54-session-video-background.jpg",
	O2_registration_header: "O2-registration-header.jpg",
	Apollo_registration_header: "Apollo-registration-header.jpg",
	'Studio 54_registration_header': "Studio54-registration-header.jpg",
};

export function getAsset(template: string, name: string): string {
	return `${process.env.REACT_APP_ASSET_SERVER}/template-assets/${Assets[`${template}_${name}`]}`;
}

export default Assets;